module.exports = {
      id: "email-usage",
      viewBox: "0 0 135.081 135.08",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#email",
      toString: function () {
        return this.url;
      }
    }